export type Role = 'owner' | 'admin' | 'user' | 'operator';
export type FolderKind = 'inbox' | 'drafts' | 'sent' | 'archive' | 'spam' | 'trash' | 'custom';
export type ScanStatus = 'clean' | 'pending' | 'blocked' | 'local_unscanned';
export const MAX_SIGNATURE_LENGTH = 20_000;
export interface SignaturePreview {
  html: string;
  text: string;
}
export interface User {
  id: string;
  tenantId: string;
  name: string;
  email: string;
  role: Role;
  status: string;
  mfaEnabled: boolean;
  signature: string;
  signatureHtml: string;
  signatureText: string;
  locale?: 'fr' | 'en';
}
export interface Mailbox {
  kind?: string;
  rights?: string[];
  id: string;
  address: string;
  quotaBytes: number;
  usedBytes: number;
}
export interface Folder {
  id: string;
  name: string;
  kind: FolderKind;
  total: number;
  unread: number;
}
export interface Attachment {
  id: string;
  name: string;
  size: number;
  contentType: string;
  scanStatus: ScanStatus;
}
export interface MessageSummary {
  id: string;
  folderId: string;
  from: string;
  fromName: string;
  to: string[];
  subject: string;
  preview: string;
  date: string;
  read: boolean;
  starred: boolean;
  size: number;
  attachments: Attachment[];
  version: number;
  submissionId?: string;
}
export interface Message extends MessageSummary {
  cc: string[];
  bcc: string[];
  text: string;
  html: string;
  headers: string;
  emailMessageId?: string;
  inReplyTo?: string;
  references?: string[];
}
export interface Draft {
  sendMode?: 'sendAs' | 'sendOnBehalf';
  id?: string;
  version?: number;
  from?: string;
  to: string[];
  cc: string[];
  bcc: string[];
  subject: string;
  text: string;
  html?: string;
  attachmentIds: string[];
  replyTo?: string;
  references?: string[];
  scheduledAt?: string;
}
export interface Domain {
  id: string;
  name: string;
  ownership: string;
  routing: string;
  token: string;
  expiresAt: string;
  lastChecked: string | null;
  records: DnsRecord[];
}
export interface DnsRecord {
  type: string;
  name: string;
  expected: string;
  actual: string[];
  ok: boolean;
  label: string;
}
export interface Bootstrap {
  companySignature?: SignaturePreview | null;
  proCollaboration?: boolean;
  oidcEnabled?: boolean;
  accessibleMailboxes?: { id: string; address: string; kind: string; rights: string[] }[];
  mailApplications?: boolean;
  user: User;
  mailbox: Mailbox | null;
  organization: {
    id: string;
    name: string;
    plan: string;
    status: string;
    policy?: Record<string, unknown>;
    policy_version?: number;
  };
  folders: Folder[];
  fromAddresses: string[];
  csrfToken: string;
  mode: string;
  mailBackend?: string;
  autoReply?: { active: boolean; endsAt: string | null } | null;
  scheduledCount?: number;
}
export interface Submission {
  id: string;
  status: string;
  recipients: { address: string; status: string; detail?: string }[];
  createdAt: string;
  scheduledAt?: string | null;
  subject?: string;
  draftId?: string | null;
  error?: string | null;
}
